var _defs, _g, _path, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "52ef99c889"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.398438 3 L 582 3 L 582 397 L 26.398438 397 Z M 26.398438 3 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6044319f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 622 91 L 741.898438 91 L 741.898438 760 L 622 760 Z M 622 91 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52ef99c889)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9bbbd",
    d: "M 363.484375 80.75 L 446.382812 80.75 L 342.707031 184.449219 L 161.207031 184.449219 L 26.398438 350.3125 L 88.660156 396.988281 L 197.546875 262.238281 L 378.980469 262.238281 L 503.429688 137.773438 L 503.429688 225.914062 L 581.257812 225.914062 L 581.257812 3.023438 L 363.484375 3.023438 L 363.484375 80.75 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b9bbbd",
    d: "M 264.949219 376.222656 L 384.191406 376.222656 L 384.191406 759.835938 L 264.949219 759.835938 L 264.949219 376.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9bbbd",
    d: "M 78.238281 511.039062 L 197.480469 511.039062 L 197.480469 764.976562 L 78.238281 764.976562 L 78.238281 511.039062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9bbbd",
    d: "M 446.382812 282.9375 L 565.691406 282.9375 L 565.691406 759.835938 L 446.382812 759.835938 L 446.382812 282.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6044319f7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9bbbd",
    d: "M 622.671875 91.164062 L 741.980469 91.164062 L 741.980469 759.835938 L 622.671875 759.835938 L 622.671875 91.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.9f3c500bbad487fcc61f28cc6d93c3da.svg";
export { ForwardRef as ReactComponent };